import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SettingsService } from '../../services/settings.service';
import { Settings } from '../../models/settings.model';

@Component({
  selector: 'app-settings',
  standalone: false,
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {

  constructor(private settingsService:SettingsService) { }

  settingsForm!: FormGroup;

  mode: 'edit' | 'display' = 'display';

  settings: Settings | null = null

  ngOnInit(): void {
    // First get the settings from the service
    this.settingsService.get().subscribe((settings) => {
      this.settings = settings;
      this.settingsForm = new FormGroup({
        pricePerSqM: new FormControl<number>(settings.pricePerSqM, [Validators.required, Validators.min(0), Validators.pattern('^\\d+(\\.\\d{1,2})?$')]),
      });
    });
  }

  edit() {
    this.mode = 'edit';
  }

  save() {
    if (this.settingsForm.invalid) {
      return;
    }
    this.settingsService.update(this.settingsForm.value).subscribe((settings) => {
      this.settings = settings;
      this.settingsForm.patchValue(this.settings);
      this.mode = 'display';
    });
  }
  
  cancel() {
    this.mode = 'display';
    this.settingsForm.reset(this.settings);
  }
}
